<template>
  <el-dialog
    :title="form.id > 0 ? '编辑物资申请' : '添加物资申请'"
    :visible.sync="visible"
    label-width="100px"
    width="900px"
    @close="$emit('update:show', false)"
    @open="handleOpen"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="mini"
    >
      <el-form-item label="申请基地" prop="base_id">
        <BaseSelect v-model="form.base_id" :filterBlank="true"></BaseSelect>
      </el-form-item>
      <el-form-item label="审批基地" prop="approve_base_id">
        <BaseSelect
          v-model="form.approve_base_id"
          :filterBlank="true"
        ></BaseSelect>
      </el-form-item>
      <el-form-item label="申请备注" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="物资明细">
        <el-table border :data="form.items" size="mini">
          <el-table-column label="类型" width="125" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.category">
                <el-option
                  v-for="(k, v) in ApplyItemCategoryMap"
                  :key="v"
                  :label="k"
                  :value="parseInt(v)"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="名称" align="center">
            <template slot-scope="scope">
              <ProductTemplateSelect
                key="apply_category_1"
                v-if="scope.row.category == 1"
                :category="1"
                v-model="scope.row.product_template_id"
              ></ProductTemplateSelect>
              <ItemTemplateSelect
                key="apply_category_2"
                v-else-if="scope.row.category == 2"
                :category="1"
                v-model="scope.row.item_template_id"
              ></ItemTemplateSelect>
              <ProductTemplateSelect
                key="apply_category_3"
                v-else-if="scope.row.category == 3"
                :category="2"
                v-model="scope.row.product_template_id"
              ></ProductTemplateSelect>
              <ItemTemplateSelect
                key="apply_category_4"
                v-else-if="scope.row.category == 4"
                :category="2"
                v-model="scope.row.item_template_id"
              ></ItemTemplateSelect>
            </template>
          </el-table-column>
          <el-table-column
            label="型号"
            prop="model_number"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <el-input
                class="text-center"
                v-if="scope.row.category"
                :ref="scope.column.property"
                v-model="scope.row.model_number"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            prop="quantity"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="scope.row.category"
                style="width: 100px"
                :controls="false"
                :ref="scope.column.property"
                v-model.number="scope.row.quantity"
                :min="1"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-input
                class="text-center"
                v-if="scope.row.category"
                :ref="scope.column.property"
                v-model="scope.row.remark"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-link
                slot="reference"
                type="danger"
                class="font-12"
                :underline="false"
                @click="form.items.splice(scope.$index, 1)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <el-button
          class="mt-10"
          size="mini"
          type="primary"
          @click="handleAddItem"
          >添加物资</el-button
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >保 存</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { applyNew, applyUpdate } from '@/service/getData'
import BaseSelect from '@/components/select/base_select'
import { ApplyItemCategoryMap } from '@/config/global'
import ItemTemplateSelect from '@/components/select/item_template_select'

export default {
  components: {
    BaseSelect,
    ItemTemplateSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      ApplyItemCategoryMap,
      formData: {
        base_id: this.$store.state.userInfo.base_id || '',
        approve_base_id: '',
        items: [],
        remark: '',
      },
      form: {},
      visible: this.show,
      rules: {
        base_id: [
          { required: true, message: '请选择申请基地', trigger: 'change' },
        ],
        approve_base_id: [
          { required: true, message: '请选择审批基地', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.form = this.formData
  },
  methods: {
    handleOpen() {
      if (this.model && this.model.id) {
        this.form = this.model
      } else {
        this.form = this.clone(this.formData)
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      }
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.id > 0) {
            let res = await applyUpdate(this.form)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await applyNew(this.form)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          return false
        }
      })
    },

    handleAddItem() {
      this.form.items.push({
        category: '',
        product_template_id: '',
        item_template_id: '',
        model_number: '',
        remark: '',
        quantity: 1,
      })
      // this.$nextTick(() => {
      //   this.$refs['category'].focus()
      // })
    },
  },
}
</script>